import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=6dec6f6a&scoped=true"
import script from "./Placeholder.vue?vue&type=script&lang=ts"
export * from "./Placeholder.vue?vue&type=script&lang=ts"
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=6dec6f6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dec6f6a",
  null
  
)

export default component.exports